import React__default from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SoundMutedIcon = (props) => /* @__PURE__ */ React__default.createElement(
  "svg",
  __spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.165 4.12907C13.312 3.99607 13.525 3.96307 13.703 4.04307C13.884 4.12307 14 4.30307 14 4.50007V19.5001C14 19.6971 13.884 19.8771 13.703 19.9571C13.638 19.9861 13.569 20.0001 13.5 20.0001C13.379 20.0001 13.259 19.9561 13.166 19.8711L8.312 15.4981L5.5 15.5001C4.673 15.5001 4 14.8271 4 14.0001V10.0001C4 9.17307 4.673 8.50007 5.5 8.50007H8.315L13.165 4.12907ZM13 5.62407L8.844 9.36907C8.778 9.42907 8.699 9.46907 8.612 9.48707C8.579 9.49407 8.535 9.50007 8.5 9.50007H5.5C5.224 9.50007 5 9.72507 5 10.0001V14.0001C5 14.2751 5.224 14.5001 5.5 14.5001L8.504 14.4981L8.58469 14.5046C8.69 14.5219 8.7852 14.5723 8.858 14.6451L13 18.3771V5.62407ZM20.2915 9.50207L20.9985 10.2091L19.2065 12.0001L20.9985 13.7911L20.2915 14.4981L18.4995 12.7071L16.7085 14.4981L16.0015 13.7911L17.7925 12.0001L16.0015 10.2091L16.7085 9.50207L18.4995 11.2931L20.2915 9.50207Z",
      fill: "currentColor"
    }
  )
);

export { SoundMutedIcon as default };
//# sourceMappingURL=SoundMutedIcon.js.map
